import { ChatbotCustomizations } from '@servicetitan/titan-chatbot-api';

type IsDefaultSelectedFn = NonNullable<
    NonNullable<ChatbotCustomizations['filters']>['isDefaultSelected']
>;

/**
 * Default filter selection logic for Atlas chatbot.
 * Selects all sources except SalesforceCases and ConfluenceOnboarding by default.
 */
export const isDefaultFilterSelected: IsDefaultSelectedFn = (filterKey, optionKey) => {
    if (filterKey === 'Sources') {
        return optionKey !== 'SalesforceCases' && optionKey !== 'ConfluenceOnboarding';
    }
    return false;
};
